import React from 'react';
import { Link } from 'react-router-dom';

function HomeHouseItem({ house }) {
    if (!house) return null;

    return (
        <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow group border border-outline-variant/10">
            <div className="relative h-64 overflow-hidden">
                <Link to={`/house/${house.slug}`}>
                    <img 
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" 
                        src={house.image} 
                        alt={house.name} 
                    />
                </Link>
                
                {house.category?.name && (
                    <div className="absolute top-4 left-4 bg-primary text-white px-3 py-1 rounded text-xs font-bold uppercase tracking-widest">
                        {house.category.name}
                    </div>
                )}
            </div>

            <div className="p-6">
                <Link to={`/house/${house.slug}`}>
                    <h4 className="text-xl font-bold mb-2 group-hover:text-primary transition-colors">
                        {house.name}
                    </h4>
                </Link>
                
                <p className="text-on-surface-variant text-sm mb-4">
                    {house.bedrooms || 0} Bedrooms • {house.bathrooms || 0} Bathrooms • {house.square_meters || 0} sqft
                </p>

                <div className=" pt-4 border-t border-outline-variant/30 flex items-center">                    
                    <Link 
                        to={`/house/${house.slug}`}
                        className="flex-1 w-full btn-wide px-4 py-3 bg-surface-container text-primary font-black text-[10px] rounded-xl hover:bg-primary hover:text-white transition-all text-center uppercase tracking-widest"
                    >
                        Details
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default HomeHouseItem;